const getScriptInDOM = (windowReference: Window, src: string): HTMLScriptElement | undefined => {
    const scripts = windowReference.document.getElementsByTagName('script');
    for (let i = scripts.length; i--; ) {
        if (scripts[i].src === src) {
            return scripts[i];
        }
    }
    return undefined;
};

const refs: { [key: string]: Promise<void> } = {};

export const loadScript = (
    windowReference: Window,
    url: string,
    debugMode: boolean
): { loadPromise: Promise<void>; alreadyExists?: boolean } => {
    if (url in refs) {
        return { loadPromise: refs[url], alreadyExists: true };
    }
    const script = getScriptInDOM(windowReference, url);
    if (script) {
        return {
            loadPromise: new Promise((_, reject) => {
                reject(new Error('Attempted to load script already present'));
            })
        };
    }
    refs[url] = new Promise((resolve, reject) => {
        const scriptElement: HTMLScriptElement = windowReference.document.createElement('script') as HTMLScriptElement;
        scriptElement.onload = () => {
            // In debug mode the script does not set google_tag_manager after loaded, so it tries again forever
            if (debugMode) {
                const checkForTagManager = () => {
                    const tagManager = !!(windowReference as any)?.google_tag_manager;
                    if (!tagManager) {
                        setTimeout(checkForTagManager, 1000);
                    } else {
                        resolve();
                    }
                };
                setTimeout(checkForTagManager, 1);
            } else {
                setTimeout(resolve, 1);
            }
        };
        scriptElement.onerror = () => {
            reject(new Error('Failed to load script'));
        };
        scriptElement.async = true;
        scriptElement.src = url;
        windowReference.document.head.appendChild(scriptElement);
    });

    return { loadPromise: refs[url] };
};
